// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  PromoteTtwPageResult,
} from "./types";

export const params = {
  ttwPage: __t.uuid(),
  name: __t.string(),
  targetAmountCents: __t.i64(),
  maxAmountCents: __t.i64(),
  minCheckSizeCents: __t.i64(),
  startDateMs: __t.i64(),
  endDateMs: __t.i64(),
  maxPerInvestorCents: __t.option(__t.i64()),
};
export const returnType = PromoteTtwPageResult